import React, { type PropsWithChildren } from 'react'
import { cn, type UtilityClassNames } from '@s4l/utility-css'

import { Typography } from '../../index'
import { IconSuccessFilled } from '@s4l/icons/IconSuccessFilled'
import { IconRadioButtonUnchecked } from '@s4l/icons/IconRadioButtonUnchecked'

import styles from './styles.module.css'

export type SelectableOptionVariant = 'default' | 'selected' | 'hover' | 'error'

interface ISelectableOptionProps {
  className?: UtilityClassNames
  onClick?: (value: { value: string }) => void
  title: string
  value: string
  variant?: SelectableOptionVariant
}

export default function SelectableOption({
  children,
  className,
  onClick,
  title,
  value,
  variant = 'default',
}: PropsWithChildren<ISelectableOptionProps>) {
  const handleClick = () => {
    onClick?.({ value })
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleClick()
    }
  }

  const classNames = cn(styles.selectableOption, styles[variant], className)

  return (
    <div
      className={classNames}
      data-value={value}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="option"
      tabIndex={0}
      aria-selected={variant === 'selected'}
    >
      <div className={styles.content}>
        <Typography as="p" variant="body" size="l" clamp={3} bold>
          {title}
        </Typography>
        {children}
      </div>
      {variant === 'selected' && <IconSuccessFilled color="var(--color-primary-500)" />}
      {variant !== 'selected' && <IconRadioButtonUnchecked />}
    </div>
  )
}
